// extracted by mini-css-extract-plugin
export default {"parent-mode":"or-separator_parent-mode__IYWxY","line":"or-separator_line__Vn7OA","or":"or-separator_or__0kohO"};